import { render, staticRenderFns } from "./TNewsSeoEn.vue?vue&type=template&id=2db83742&"
import script from "./TNewsSeoEn.vue?vue&type=script&lang=js&"
export * from "./TNewsSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports